import { render } from "./HomeworkStatusBadges.vue?vue&type=template&id=caa31dec"
import script from "./HomeworkStatusBadges.vue?vue&type=script&lang=js"
export * from "./HomeworkStatusBadges.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__